﻿const ja = {
    application_title: 'Login',
    japanese: '日本語',
    english: 'English',
    french: 'French',
    german: 'German',
    italian: 'Italian',
    spanish: 'Spanish',
    language: '言語選択',
    login_selectscreen: '画面選択',
    login_all: '全て',
    login_executive: '経営者向け',
    login_manager: '管理者向け',
    login_operator: '現場向け',
    login_forgot_password: 'パスワードを忘れた場合',
    user_id: 'ユーザー名',
    user_password: 'パスワード',
    authorizer: '承認者',
    authorizer_text: '注：\n 承認者のEメールアドレスを入力してください。\n承認者が不明な場合は各販社の商品担当者にお問合せください。',
    sign_in: 'ログイン',
    sign_in_error: 'ユーザー名、またはパスワードに誤りがあります',
    create_account: '新規アカウント作成',
    forget_password_title: 'パスワードリセットの依頼を下記メールアドレスまでお願いします。',
    forget_password_email: 'dashboard-u_support2@gcp.konicaminolta.com',
    forget_password_text: '・以下のテキストをコピーし、件名に貼り付けてメール送付してください。\n\
    >【リクエスト】パスワードリセット \n\
・メール本文は空欄で構いません。\n\
・メールは本ソフトウェアに登録しているメールアドレスより送付頂きますようお願いします。\n\
・登録されていないメールアドレスからのリクエストにはお答えできない場合がございます。\n\
・24営業時間以内に返答がない場合は、再送をお願いします。\n\
※このメールは送信専用のメールアドレスから配信されています。ご返信いただいてもお答えできませんのでご了承ください。\n\
・新規パスワードの通知は下記メールアドレスからご確認ください。\n\
"no-reply@verificationemail.com"',
    forget_password_team: 'AccurioPro Dashboard Op-Analysis運営チーム',
    privacy_statement: 'Privacy Statement',
    privacy_statement_contents: '【個人情報の取り扱いについて】\n\n\
コニカミノルタ株式会社及びコニカミノルタジャパン株式会社（以下、「弊社」といいます）は、AccurioPro Dashboard（以下、「本サービス」といいます）を用いたサービスを顧客に提供するにあたり、貴方より取得させていただく個人情報につきまして、コニカミノルタグループ個人情報保護方針に定めるほか、その取扱いに関する事項を以下のとおり通知いたします。\n\n\
１．貴方よりお預かりした個人情報の利用 \n\
貴方が本サイトをご利用いただくための登録に際して、e-mailアドレス（以下、「個人情報」といいます）をご提供いただきます。弊社は、貴方の個人情報を、顧客に対して本サービスを提供するにあたり必要な目的（以下の各号の目的を含みますが、これらに限られません。以下、「利用目的」といいます）のために利用いたします。\n\
① 本人確認 \n\
② AccurioPro Dashboardに関して必要な情報の提供 \n\n\
２．第三者への個人情報の提供・開示 \n\
弊社は、次の各号に該当する場合を除き、個人情報を第三者に提供、開示等することはありません。 \n\
(1)貴方の同意がある場合 \n\
(2)利用目的を遂行するために必要な範囲において、弊社が適切な管理監督を行う業務委託先に提供する場合 \n\n\
３．個人情報の共同利用 \n\
弊社は、利用目的を遂行するために必要な範囲内において、取得した個人情報を、グループ会社との間で共同して利用させていただくことがあります。なお、共同して利用する個人データの項目は、e-mailアドレスとします。また、共同利用における個人情報の管理責任者は、コニカミノルタ株式会社(所在地：東京都千代田区丸の内2－7－2、代表取締役社長：大幸 利充)とします。 \n\n\
４．お問い合わせ窓口 \n\
弊社にご提供いただいた個人情報の開示、変更、訂正、利用停止等を希望される場合や本通知に関するお問い合わせについては、下記の窓口までお願いいたします。 \n\n\
コニカミノルタ株式会社 \n\
プロフェッショナルプリント事業本部 開発統括部 市場デジタル化推進部 \n\
メールアドレス：dashboard-u_support1@gcp.konicaminolta.com \n\n\
以上',
    register: '登録',
    update: '更新',
    email: 'Eメールアドレス',
    fields_compulsory: '全てのフィールドを入力してください。\n',
    authorizer_email_error: '承認者のEメールアドレスは有効ではありません。\n',
    email_error: 'Eメールアドレスは有効ではありません。\n',
    username_error: 'ユーザー名は英数字のみ入力可能です。\n',
    serial_number_duplicate_error: 'シリアルナンバーが重複しています。\n',
    password_match_error: 'パスワードが一致していません。\n',
    not_km_domain: '承認者のEメールアドレスのドメインはコニカミノルタではありません。\n',
    registered: '登録済み!!',
    add_account_email_text: '{authorizer}様、%0D%0A%0D%0A{email}は、AccurioPro DashboardOp-Analysisのアカウントを作成しました。%0D%0A%0D%0A\n\n\
コニカミノルタの会員でない方は、コニカミノルタのユーザーの承認を得て、このアプリケーションを使用できます。%0D%0A\n\
したがって、以下のURLにログインして、承認してください。%0D%0A%0D%0A\n\n\
URL %0D%0A\n\
{url} %0D%0A%0D%0A\n\n\
よろしくお願いいたします。%0D%0A\n\
コニカミノルタ株式会社%0D%0A\n\n\
',
    customer_email_text: '{email}様%0D%0A%0D%0A\
Printer Performance Analysis toolのアカウントを作成しました。%0D%0A以下のURLにログインしてください。%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
ユーザー名：{userId}%0D%0A\
パスワード：{password}%0D%0A%0D%0A\
よろしくお願いいたします。%0D%0Aコニカミノルタ株式会社',
    request_to_you: 'CEのアカウント作成リクエストを承認/非承認できます',
    http_get_error: '{status}: 処理に失敗しました。ログイン画面に戻ります',
    server_error: 'サーバーエラーが発生しました',
    http_connection_error: 'インターネットに接続されていません',
    ce_top_title: 'アカウント情報を通知する顧客を選択してください',
    add_customers_account: '顧客アカウント追加',
    go_back: 'キャンセル',
    customers: '顧客名',
    serial_numbers: '登録済シリアルナンバー',
    open: '開く',
    add_sn: '印刷機のシリアルナンバーを追加',
    add_ce: 'この顧客をフォローするCEを追加',
    printers_sn: '印刷機のシリアルナンバー',
    edit_customer_title: '顧客設定を編集',
    customer_email_address: '顧客メールアドレス',
    license: 'ライセンス',
    printers_registered: '登録済み印刷機',
    serial_number: 'シリアルナンバー',
    latest_data: '最新情報',
    persons_in_charge: '担当者',
    customer_engineer: 'カスタマー　エンジニア',
    sender: '差出人',
    authorization: '承認',
    approve: '承認',
    do_not_approve: '非承認',
    request_approved: '承認リクエストを許可しました!',
    request_disapproved: '承認リクエストを却下しました!',
    approved: '承認済み',
    do_not_approved: '拒否済み',
    processed_result: '処理結果',
    processed_date: '処理日時',
    header_nfr: 'Not for resale license (NFR)',
    header_recommendation: 'Recommendation',
    header_previous: 'Previous',
    header_next: 'Next',
    header_reset: 'Reset',
    header_change_password: 'パスワード変更',
    header_settingMenu_tutorial: 'チュートリアル',
    header_old_password: '現在のパスワード',
    header_new_password: '新しいパスワード',
    header_confirm_password: '新しいパスワード(確認)',
    header_cancel: 'キャンセル',
    header_apply: '適用',
    header_ok: 'OK',
    header_close: '閉じる',
    from: 'From',
    to: 'To',
    change_date_heading: '期間設定',
    change_date_explanation: 'CSV出力の対象期間を設定してください',
    header_password_explanation: 'パスワードは、半角アルファベット大文字小文字、数字を含む8文字以上の文字列で作成してください。',
    header_machine_setting: 'マシン設定',
    header_machine_setting_title: 'マシン設定',
    header_machine_setting_notes: 'ドラッグ＆ドロップでマシン表示順を入れ替えることができます。',
    header_machine_setting_model: 'モデル名：',
    header_machine_setting_serial_number: 'S/N：',
    header_machine_setting_machine_name: 'マシン表示名：',
    header_machine_setting_error_message_max_length: 'マシン名は半角64文字以内で入力してください。',
    header_machine_setting_error_message_min_length: 'マシン名は必ず入力してください。',
    header_machine_setting_error_message_common: '入力内容を確認してください。',
    header_machine_setting_complete_message: '更新が完了しました。画面をリロードします。',
    header_lms_setting: 'ライセンス設定',
    header_lms_explanation: 'メールで通知されたProduct Keyを入力し、「情報取得」ボタンを押した後「有効にする」ボタンを押してください。',
    header_lms_add: '追加',
    header_lms_delete: '削除',
    header_lms_pkIdTitle: 'Product Key',
    header_lms_refer: '情報取得',
    header_lms_licenseKind: 'ライセンス種類',
    header_lms_licenseDate: 'ライセンス有効期間',
    header_lms_licenseState: 'アクティベート状態',
    header_lms_activate: '有効にする',
    header_lms_deactivate: '無効にする',
    header_lms_state_activate: 'Activate',
    header_lms_state_deactivate: 'Deactivate',
    header_lms_ptl_date: 'Test License ライセンス有効期限',
    header_lms_activationDate: 'アクティベーション有効期間',
    header_lms_never_expired: '無期限',
    header_users_guide: 'ユーザーズガイド',
    header_users_guide_link: 'https://www.btapac.konicaminolta.com/users_guide/accuriopress_C14000_series/3_0_0/jp/index.html',
    header_version_info: 'バージョン情報',
    screen1_productivity_rate: '生産効率の増減',
    screen1_productivity_pred: '生産性の予実',
    screen1_week_before_last_availability: '先々週の稼働率',
    screen1_productivity_diff: '予実差',
    screen1_week_before_last_pred_diff: '先々週の予実差',
    screen1_productivity_a4_tips: '生産性はA4サイズ換算です',
    screen1_productivity_a3_tips: '生産性はA3サイズ換算です',
    screen1_results_of_production: '生産性結果',
    screen1_est_print_time: '想定印刷時間(hh:mm)',
    screen1_act_print_time: '実績印刷時間(hh:mm)',
    screen1_gap: '予実差(hh:mm)',
    screen1_sheets: '実績印刷面数',
    screen1_sheets_per_h: '生産能力(面/時)',
    screen1_availability: 'マシン稼働率 (%)',
    screen1_job_list_link: 'ジョブ一覧',
    screen1_machine_list_link: 'マシン一覧',
    top_manager_title_production_result: '集計一覧',
    top_manager_title_prints: '実績',
    top_manager_title_errors: 'エラー',
    top_manager_jobs: '処理したジョブ数（回）',
    top_manager_color_pv: 'カラー印刷（頁）',
    top_manager_bw_pv: 'モノクロ印刷（頁）',
    top_manager_output_paper: '排紙枚数（枚）',
    top_manager_trayfull_count: 'トレイフル（回）',
    top_manager_paperjams__count: '紙詰まり（回）',
    top_manager_servicecall_count: 'サービスコール（回）',
    top_manager_paperempty_count: '用紙切れ（回）',
    top_manager_tonerempty_count: 'トナー切れ（回）',
    top_operator_title_production_result: 'マシン稼働実績データ',
    top_operator_title_trouble_result: '集計一覧',
    top_operator_subtitle_output_paper_result: '排紙枚数の推移',
    top_operator_subtitle_output_availability_result: '分類別の時間分析',
    top_operator_paper_count: '排紙枚数実績',
    top_operator_subtitle_output_paper_count: '排紙枚数(枚)',
    top_operator_subtitle_interruption_result: '印刷中断要因の特定 (単位：分)',
    top_operator_trayfull: 'トレイフル',
    top_operator_paperempty: '用紙切れ',
    top_operator_tonerempty: 'トナー切れ',
    top_operator_paperjams: '紙詰まり',
    top_operator_servicecall: 'サービスコール',
    top_operator_explanation_worst1: '最も時間がかかった中断要因 ',
    top_operator_explanation_worst2: '2番目 ',
    top_operator_explanation_worst3: '3番目 ',
    screen3_print_hours: '時間',
    listofprintjobs_title: 'ジョブ一覧',
    listofprintjobs_number: 'No.',
    listofprintjobs_start_time: '開始時刻',
    listofprintjobs_job_id: 'ジョブ ID',
    listofprintjobs_pages_set: 'PV/部',
    listofprintjobs_output_set: '出力 部数',
    listofprintjobs_exit_count: '排紙 枚数',
    listofprintjobs_machine_name: 'マシン',
    jobdetail_left_title: 'ジョブ詳細',
    jobdetail_timeline_title: '出力タイムライン',
    jobdetail_job_id: 'ジョブID',
    jobdetail_size: '紙サイズ',
    jobdetail_paper_kind: '紙種',
    jobdetail_paper_weight: '坪量/紙厚',
    jobdetail_color: 'モノクロ/カラー',
    jobdetail_side: '片面/両面',
    jobdetail_pages: 'ページ/部',
    jobdetail_unit_pages: '頁',
    jobdetail_units: '出力部数',
    jobdetail_unit_units: '部',
    jobdetail_sheets: '排紙枚数',
    jobdetail_unit_sheets: '枚',
    jobdetail_center_title: 'マシン',
    jobdetail_machine_name: 'マシン',
    jobdetail_tray_full: 'トレイフル（回）',
    jobdetail_paper_empty: '用紙切れ（回）',
    jobdetail_toner_empty: 'トナー切れ（回）',
    jobdetail_paper_jam: '紙詰まり（回）',
    jobdetail_service_call: 'サービスコール（回）',
    jobdetail_panel_operation: 'パネル操作',
    jobdetail_frontdoor_open: 'フロントドアオープン',
    jobdetail_tray_open: 'トレイオープン',
    jobdetail_right_title: 'ジョブの想定値と実績値の予実差',
    jobdetail_graph_x_title: '想定印刷時間[分]',
    jobdetail_graph_y_title: '実績印刷時間[分]',
    jobdetail_legend_jobs: '{machineName}で出力されたジョブ',
    jobdetail_legend_target: '対象ジョブ',
    jobdetail_tooltip_jobid: 'ジョブID: ',
    jobdetail_tooltip_diff: '予実差: ',
    jobdetail_tooltip_actual: '実績値: ',
    jobdetail_tooltip_assumed: '想定値: ',
    jobdetail_start_time: '開始時刻',
    jobdetail_end_time: '終了時刻',
    availabilitydetail_left_title: 'マシン一覧',
    availabilitydetail_center_title: 'マシン別の時間分析',
    availabilitydetail_right_title: '印刷時間の傾向',
    availabilibydetail_unit_hour: '時間[h]',
    availabilibydetail_machine: 'マシン',
    availabilibydetail_unit_idle: 'アイドル時間',
    availabilibydetail_unit_interruption: '印刷中断時間',
    availabilibydetail_unit_preparation: '印刷準備時間',
    availabilibydetail_unit_printing: '印刷時間',
    joblist_title: 'ジョブ一覧',
    joblist_number: 'No.',
    joblist_estprinttime: '想定印刷時間 (hh:mm)',
    joblist_actprinttime: '実績印刷時間 (hh:mm)',
    joblist_hourlyunits: '面数/時',
    joblist_printcompletedtime: '印刷時間 (hh:mm)',
    joblist_printtimediff: '予実差 (hh:mm)',
    joblist_csv_export: 'CSV出力',
    joblist_est_hourlyunits: '想定面数/時',
    joblist_est_printcompletedtime: '想定印刷時間 (hh:mm)',
    joblist_act_hourlyunits: '実績面数/時',
    joblist_act_printcompletedtime: '実績印刷時間 (hh:mm)',
    proddetail_title: '印刷時間の予実差',
    proddetail_table_title: '生産数量の傾向',
    proddetail_graph_yaxis_left: '印刷時間 (hh:mm)',
    proddetail_graph_yaxis_right: '達成率 (%)',
    proddetail_est_print_time: '想定印刷時間',
    proddetail_act_print_time: '実績印刷時間',
    proddetail_gap: '予実差 (hh:mm)',
    proddetail_duration_daily: '日',
    proddetail_duration_weekly: '週',
    proddetail_duration_monthly: '月',
    machinedetail_left_title: 'マシン詳細',
    machinedetail_center_title: 'エラー',
    machinedetail_right_title: '稼働詳細',
    machinedetail_availability: '稼働率',
    machinedetail_operating_time: '電源ON時間 (時間)',
    machinedetail_printing_time: '印刷時間 (時間)',
    machinedetail_output_set: '出力部数 (部)',
    machinedetail_output_paper: '排紙枚数 (枚)',
    machinedetail_power_on: '電源ON',
    machinedetail_power_off: '電源OFF',
    common_min_per_week: '分/週',
    common_2days_ago: '一昨日',
    common_yesterday: '昨日',
    common_today: '本日',
    common_tomorrow: '明日',
    common_2days_after: '明後日',
    common_2weeks_ago: '先々週',
    common_last_week: '先週',
    common_this_week: '今週',
    common_next_week: '来週',
    common_2weeks_after: '再来週',
    common_2months_ago: '先々月',
    common_last_month: '先月',
    common_this_month: '今月',
    common_next_month: '来月',
    common_2months_after: '再来月',
    common_days_ago: '{dateNum}日前',
    common_weeks_ago: '{dateNum}週前',
    common_months_ago: '{dateNum}ヶ月前',
    common_days_after: '{dateNum}日後',
    common_weeks_after: '{dateNum}週後',
    common_months_after: '{dateNum}ヶ月後',
    common_mins: '分',
    common_hours: '時間',
    common_date: '日付',
    common_percentage: '%',
    icon_recommendation: 'Recommendation',
    icon_analysis: '分析',
    icon_operation: 'オペレーション',
    icon_machine: '機械',
    icon_material: '材料',
    icon_method: '方法・プロセス',
    icon_running_time: '印刷時間',
    icon_preparation_time: '印刷準備時間',
    icon_downtime: '印刷中断時間',
    paperEmpty: '用紙切れ',
    tonerEmpty: 'トナー切れ',
    trayFull: 'トレイフル',
    Total: '合計',
    Average: '平均',
    hour_unit: '時間',
    date_format: 'YYYY/MM/DD',
    date_format2: 'MM/DD',
    month_format: 'YYYY/MM',
    errCode_10000: 'パスワード変更に失敗しました。',
    errCode_10001: '新しいパスワードと新しいパスワード(確認)が一致しません。',
    errCode_10002: 'パスワードは、半角アルファベット大文字小文字、数字を含む8文字以上の文字列とする必要があります。',
    errCode_10003: '10分程度時間を置いてから再度パスワード変更をお願いします。',
    errCode_10004: '現在のパスワードが間違っています。',
    errCode_10005: 'セッションタイムアウトが発生しました。再度ログインしてください。',
    errCode_10006: 'ネットワークエラーが発生しました。',
    errCode_10100: 'エラーが発生しました。管理者にお問い合わせください。',
    errCode_10101: 'Product Keyを入力してください。',
    errCode_10102: 'Product Key情報の取得に失敗しました。',
    errCode_10103: 'アクティベートに失敗しました。',
    errCode_10104: 'ディアクティベートに失敗しました。',
    errCode_10105: 'Product Key情報の削除に失敗しました。',
    errCode_10106: '同じProduct Keyを設定することはできません。',
    errCode_10007: '認証メールを確認し、メール本文のリンクからログインしてください。',
    errCode_20000: '指定された値に誤りがあります。',
    errCode_20001: '指定されたメールアドレスは既に登録済みです。',
    errCode_20002: '指定されたユーザー名は既に登録済みです。他のユーザー名を指定してください。',
    errCode_20003: '指定されたユーザー名は顧客として登録されていません。',
    suggestion_overview: '概要',
    suggestion_pgap_overview_good: '予実差が縮まりました',
    suggestion_pgap_overview_bad: '予実差が広がりました',
    suggestion_pgap_overview_even: '予実差に変化ありません',
    suggestion_ma_overview_good: '稼働率が上がりました',
    suggestion_ma_overview_bad: '稼働率が下がりました',
    suggestion_ma_overview_even: '稼働率に変化ありません',
    suggestion_attention_machine: '要注意マシン: ',
    suggestion_tips: 'Tips',
    suggestion_pv_up: '印刷量が増えました',
    suggestion_pv_down: 'PVが下がっています',
    suggestion_pv_even: '印刷量に変化ありません',
    suggestion_downtime_long: 'ダウンタイムが多くなりました',
    suggestion_smalljob_many: '小ロットジョブが増えました',
    suggestion_efficiency_up: '生産効率が上がりました',
    ce_login_tutorial: '導入に際して、チュートリアルを参照する',
    ce_dialog_header_confirm: '確認',
    ce_confirmation_message: 'この内容で更新します。よろしいですか？',
    ce_email_confirmation: 'この顧客のパスワードを初期化し、メールを作成します。よろしいですか？',
    username_email: 'ユーザー名（Eメールアドレス）',
    ce_dialog_header_info: 'お知らせ',
    ce_account_complete_kmce: 'アカウント登録が完了しました。ログイン画面に移動します。',
    ce_account_complete_dealer: 'アカウント登録依頼が完了しました。承認されるまでお待ちください。',
    ce_user_account_complete_kmce: 'アカウント登録が完了しました。',
    ce_user_account_complete_dealer: 'アカウント登録依頼が完了しました。承認されるまでお待ちください。',
    ce_error_400: '編集した内容に誤りがあります。内容をご確認ください。',
    ce_error_409: '他ユーザーが更新しているため、情報を再取得します',
    ce_top_operator_user_name: '{userName}の現場層画面',
    add_new_customer: '新規顧客追加',
    add_existed_customer: '既存顧客追加',
    ce_edit_licenseExpiresOn: '使用期限',
    send_mail: 'メールを送信しました',
    password_change_complete: 'パスワード変更が完了しました',
    reset_password: 'パスワードリセット',
    change_button: '変更',
    send_button: '送信',
    common_error_500: '処理に失敗しました。',
    error_send_mail: 'メール送信に失敗しました。',
    error_confirm_password_incorrect: 'パスワードと確認用パスワードが異なっています。',
    error_usename_not_exist: '指定されたユーザー名は存在しません。',
    error_id_not_exist: '指定されたIDは存在しません。',
    error_id_mailaddress_not_exist: '指定されたID、またはEメールアドレスが存在しません。',
    ce_forget_password_dialog_message: 'パスワードリセットメールが送信されますので、メール本文に記載されたURLからパスワード変更を行ってください。',
    user_forget_password_dialog_message: 'このアカウントを利用する全メンバーに影響がありますので、変更するか再度ご確認ください。パスワードリセットメールが送信されますので、メール本文に記載されたパスワードでログインを行ってください。メールアドレスが不明な場合は担当CEにお問合せください。',
    Mon: '月',
    Tue: '火',
    Wed: '水',
    Thu: '木',
    Fri: '金',
    Sat: '土',
    Sun: '日',
    header_pending_verification: 'メールの応答確認待ち',
    pending_verification_dialog_message: 'アカウントが長期使用されていないため停止されています。確認メールを送信してよろしいですか？',
    trial_license_expired_message: 'トライアルライセンスの期限切れです。プロダクトキーを入力してください',
    errCode_20004: '無効なURLです',
    error_code: 'エラーコード',
    jam_location: 'ジャム個所',
    device_time: '発生時刻',
    machine_name: '発生マシン',
    paperJamsList_title: '紙詰まり一覧',
    error_support: '解除手段',
    error_describe: 'エラー発生個所（エラー内容）',
    serviceCallList_title: 'サービスコール一覧',
    tray: '用紙トレイ/フィーダー',
    paperEmptyList_title: '用紙切れ一覧',
    output_tray_name: '排紙トレイ',
    trayFullList_title: 'トレイフル一覧',
    tonerEmptyList_title: 'トナー切れ一覧',
    toner_color: 'トナー色',
    errorCount_tip: '解析または件数制限のため、一覧表示を中断しました',
    solve_time: '解消時刻',
    change_language: '言語選択',
    machine_tab: '標準',
    custom_group_tab: 'カスタムグループ',
    group_name: 'グループ名称',
    group_checkbox_tip: 'チェックを入れたグループが、UI上で選択できます',
    group_edit_tip: 'マシン表示のカスタムセットを追加することができます。',
    custom_group: 'カスタムグループ名称',
    group_comment: 'コメント',
    machine_checkbox_tip: 'チェックを入れたマシンがグループ選択時に集計されます',
    group_name_exits: '指定されたグループ名は既に存在します',
    header_group_name_max_length: 'グループ名は半角64文字以内で入力してください。',
    header_group_name_min_length: 'グループ名は必ず入力してください。',
    header_group_comment_max_length: 'コメントは半角128文字以内で入力してください。',
    header_device_group_switch: 'デバイスグループ:',
    header_group_all: '全て(シート)',
    header_group_color: 'カラー',
    header_group_monochrome: 'モノクロ',
    header_group_detail_length: 'カスタムグループにはマシンを一つ以上選択してください。',
    header_group_select_tip: 'グループにマシンがありません。マシンを登録してください。',
    group_name_specialchar_tip: '特殊文字@は入力できません',
    change_date_heading_week: '週選択',
    machine_time_line: 'タイムライン',
    header_group_ppall: 'AccurioPress/Print',
    header_group_km1: 'AccurioJet',
    top_manager_otherTransporterror_count: 'その他搬送エラー(回)',
    otherTransportErrorList_title: 'その他搬送エラー一覧',
    jobdetail_otherTransporterror: 'その他搬送エラー(回)',
    top_operator_otherTransporterror: 'その他搬送エラー',
    errCode_10008: 'キーが間違っているか、有効期限外です。',
    feeder: 'フィーダー',
    license_expired_message: 'ライセンスの有効期限が切れています',
    logout_dialog_msg: 'ライセンス有効まで全機能使えません。ログアウトしますか。',
    header_logout_yes: 'ログアウト',
    header_logout_no: 'キャンセル',
    paper_weight: '坪量',
    paper_thickness: '紙厚',
    errCode_10009: '該当SNは登録されていません',
    errCode_10010: 'ログインが必要です',
    errCode_10011: 'デバイスが登録されていません',
    ce_reset_password_dialog_title: '顧客アカウント情報通知',
    ce_reset_password_dialog_ultimate: 'Op-Analysisをリセット',
    ce_reset_password_dialog_job_manager: 'JobManagerをリセット',
    ce_reset_password_dialog_all: '両方をリセット',
    ce_reset_password_dialog_job_manager_schedule: '新JobManagerをリセット',
    customer_email_text_job_manager: '{email}様%0D%0A%0D%0A\
AccurioPro Dashboard JobManagerのアカウントを作成しました。%0D%0A以下のURLにログインしてください。%0D%0A\
URL: https://dashboard-jm.konicaminolta.com%0D%0A\
ユーザー名：{userId}%0D%0A\
オペレーターID：administrator%0D%0A\
パスワード：{password}%0D%0A%0D%0A\
ライセンス設定機能でProduct Keyを入力すると、このアプリケーションのすべての機能を使用できます。%0D%0A\
※Product Keyは別途メールにてお送りします。 必ず確認してください。%0D%0A%0D%0A\
AccurioPro Dashboard JobManagerを便利に活用するためのチュートリアルをご用意しています。%0D%0A\
URL: https://dashboard-jm-tutorial.konicaminolta.com%0D%0A%0D%0A\
よろしくお願いいたします。%0D%0Aコニカミノルタ株式会社',
    customer_email_text_all: '{email}様%0D%0A%0D%0A\
AccurioPro Dashboard JobManagerとPrinter Performance Analysis toolのアカウントを作成しました。%0D%0A以下のURLにログインしてください。%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
ユーザー名：{ultimateUserId}%0D%0A\
オペレーターID：administrator%0D%0A\
JobManager パスワード：{jobManagerPassword}%0D%0A\
Analysis パスワード：{ultimatePassword}%0D%0A%0D%0A\
ライセンス設定機能でProduct Keyを入力すると、このアプリケーションのすべての機能を使用できます。%0D%0A\
※Product Keyは別途メールにてお送りします。 必ず確認してください。%0D%0A%0D%0A\
よろしくお願いいたします。%0D%0Aコニカミノルタ株式会社',
    customer_email_text_with_flux_webhook:'{email}様%0D%0A%0D%0A\
AccurioPro Dashboard JobManagerのアカウントを作成しました。%0D%0A以下のURLにログインしてください。%0D%0A\
URL: https://dashboard-jm.konicaminolta.com%0D%0A\
ユーザー名：{userId}%0D%0A\
オペレーターID：administrator%0D%0A\
パスワード：{password}%0D%0A%0D%0A\
ライセンス設定機能でProduct Keyを入力すると、このアプリケーションのすべての機能を使用できます。%0D%0A\
※Product Keyは別途メールにてお送りします。 必ず確認してください。%0D%0A%0D%0A\
AccurioPro Dashboard JobManagerを便利に活用するためのチュートリアルをご用意しています。%0D%0A\
URL: https://dashboard-jm-tutorial.konicaminolta.com%0D%0A\
Flux連携Endpoint URL：{webhookUrl}%0D%0A%0D%0A\
よろしくお願いいたします。%0D%0Aコニカミノルタ株式会社',
    TZ_0000: 'ヨーロッパ/西/イギリス・ポルトガル (+0)',
    TZ_0100: 'ヨーロッパ/中央/フランス・ドイツ(+1)',
    TZ_0200: 'ヨーロッパ/東/ウクライナ・ギリシア (+2)',
    TZ_0300: 'ヨーロッパ/トルコ・モスクワ (+3)',
    TZ_0630: 'アジア/インド (+5.5)',
    TZ_0700: 'アジア/ベトナム (+7)',
    TZ_0800: 'アジア/中国 (+8)',
    TZ_0900: 'アジア/日本・韓国 (+9)',
    TZ_1400: '米国/ハワイ (-10)',
    TZ_1500: '米国/アラスカ (-9)',
    TZ_1600: '米国/西/ロサンゼルス (-8)',
    TZ_1700: '米国/山岳/デンバー (-7)',
    TZ_1800: '米国/中央/シカゴ (-6)',
    TZ_1900: '米国/東/ニューヨーク (-5)',
    TZ_2100: '南米/東/サンパウロ (-3)',
    time_zone_title: 'タイムゾーン',
    local_time: 'ローカルタイム',
    header_user_id: 'ユーザー名',
    ce_customers_list_title: '顧客一覧',
    ultimate_license_expires_on: 'Op-Analysisの使用期限とライセンス種類',
    jm_license_expires_on: 'JobManagerの使用期限とライセンス種類',
    jm_is_include_schedule: 'スケジューリング',
    ce_customers_list_search: '検索',
    ce_edit_registered: '登録済',
    ce_edit_serialNumber: 'シリアルナンバー（印刷機）',
    ce_edit_lastUpdatedDate: '最終更新日時',
    ce_edit_responsibleCE: '担当カスタマーエンジニア',
    ce_edit_customerInfo: '顧客情報',
    ce_edit_utimate: 'Op-Analysis',
    ce_edit_addSerialNumber: 'シリアルナンバー追加',
    ce_edit_jobManager: 'Job Manager',
    ce_edit_commonInfo: '共通情報',
    ce_header_editCustomers: '顧客設定の編集',
    ce_add_addCustomers_title: '顧客のアカウントを新規追加できます',
    ce_serial_number_list: 'シリアルナンバー一覧',
    ce_essential_link_file: 'Essential連携認証ファイル',
    ce_location_on_off: 'ベータ版機能のON/OFF',
    date: '日付',
    before_suggistion: '元提案文',
    after_suggestion: '変更後提案文',
    batch_edit: '一括更新',
    data_error: 'データが更新されました。リフレッシュ後に再保存してください',
    edit_suggestion: '提案文編集',
    suggestion: '提案文',
    user_suggestion_list: '提案文一覧',
    delete_suggestion: '削除',
    top_operator_adjustment: 'メンテナンス',
    color: 'カラー',
    monochrome: 'モノクロ',
    duplex: '両面',
    simplex: '片面',
    undefined_paper: 'なし',
    normal_paper: '普通紙',
    colored_paper: '色紙',
    high_quality_paper: '上質紙',
    color_paper: 'カラー用紙',
    coated_gloss_laser_paper: '電子写真用塗工紙グロス',
    coated_mat_laser_paper: '電子写真用塗工紙マット',
    coated_gloss_offset_paper: '印刷用塗工紙グロス',
    coated_mat_offset_paper: '印刷用塗工紙マット',
    embossing_paper: 'エンボス紙',
    envelope: '封筒',
    rough_paper: 'ラフ紙',
    book_paper: '書籍用紙',
    coated_paper: 'コーティング.(塗工紙)',
    preprinted_paper: '追い刷り紙',
    blank_insert_paper: '未印字挿入紙',
    generate_suggestion: '自動生成',
    error_Duration: '解消までの時間',
    jobdetail_processing_time: '処理時間',
    job_start_time: '開始時刻',
    job_end_time: '終了時刻',
    add_customer_user_id: 'ユーザー名(顧客ログイン用ID)',
    add_customer_email_address: '顧客連絡先Eメールアドレス',
    change_date_heading_day: '日選択',
    no_log: 'Dashboard Op-Analysis用のログがCSRA/CSRCに送信されていません',
    unused_log: 'Dashboard Op-Analysis用のログがCSRA/CSRCログに含まれていません',
    datetime_format: 'YYYY/MM/DD HH:mm:ss',
    header_jobs: 'Jobs',
    no_rows_label: 'データがありません',
    date_format3: 'MM/DD HH:mm',
    aqa_main_reason_fd_k: '縦スジK',
    aqa_main_reason_fd_c: '縦スジC',
    aqa_main_reason_fd_m: '縦スジM',
    aqa_main_reason_fd_y: '縦スジY',
    aqa_main_reason_cd_k: '横スジK',
    aqa_main_reason_cd_c: '横スジC',
    aqa_main_reason_cd_m: '横スジM',
    aqa_main_reason_cd_y: '横スジY',
    aqa_main_reason_dba_k: '濃度ムラK',
    aqa_main_reason_dba_c: '濃度ムラC',
    aqa_main_reason_dba_m: '濃度ムラM',
    aqa_main_reason_dba_y: '濃度ムラY',
    aqa_main_reason_spot_k: 'スポットK',
    aqa_main_reason_spot_c: 'スポットC',
    aqa_main_reason_spot_m: 'スポットM',
    aqa_main_reason_spot_y: 'スポットY',
    aqa_main_reason_backside_stain: '裏汚れ',
    machine_detail_timeline: '稼働タイムライン',
    machine_detail_score_transition: '画像総合スコア推移',
    machine_detail_score_details: '画像診断のスコア詳細表示',
    machine_detail_diagnostic_history: '画像診断履歴(簡易/詳細)',
    machine_detail_dba_history: '最高濃度の推移',
    aqa_score_trend: 'スコア',
    aqa_score_average_28days_trend: 'トレンド(28日平均)',
    day_time: '日時',
    machine_id: 'マシンID',
    overall_score: '総合スコア',
    main_factors: '主な要因',
    machine_detail_score: '画像総合スコア',
    machine_detail_score_last_date: '最新日時',
    machine_detail_score_last_num: '最新スコア',
    machine_detail_score_average_num: '過去平均スコア',
    machine_detail_score_major_factor: '主な要因',
    machine_detail_score_last: '最新スコア:',
    machine_detail_score_average_28days: '28日平均スコア:',
    aqa_diagnostic_score_legend_error: 'エラー',
    aqa_diagnostic_score_legend_warning: '警告',
    aqa_diagnostic_score_legend_ok: '正常',
    aqa_diagnostic_score_subtitle: '診断項目',
    aqa_color: '色',
    aqa_fd_streak_rank: '縦スジ',
    aqa_cd_streak_rank: '横スジ',
    aqa_cd_banding_rank	: 'CD周期ムラ',
    aqa_blurry_white_spot: '白ホタル',
    aqa_blurry_color_spot: '色ホタル',
    aqa_white_spot: '白斑点',
    aqa_black_spot: '黒斑点',
    aqa_inky_backside: '裏汚れ',
    aqa_uneven_density: '濃度ムラ',
    aqa_dba_adapt: '(調整済)',
    aqa_quality_information: 'AQA品質情報の表示',
    ce_sn_validation: 'コニカミノルタ印刷機のシリアルナンバーは13文字です',
    aqa_history_table_title: '画像診断結果（簡易診断/詳細診断）',
    date_format4: 'YYYY/MM/DD HH:mm',
    header_group_AccurioLabel: 'AccurioLabel',
    header_group_registered_mixed_error: 'ロール紙印刷機とシート紙印刷機は混在できません',
    label_machine_printed_length: '印刷長',
    label_machine_printed_length_with_unit: '印刷長(m)',
    label_machine_act_printed_length_with_unit: '実績印刷長(m)',
    label_machine_printed_length_unit: 'm',
    label_machine_printed_length_time_unit: 'm/時',
    label_machine_printed_length_with_unit2: '印刷長/部',
    label_machine_top_operator_subtitle_printed_length_result: '印刷長の推移',
    label_machine_top_operator_act_printed_length: '印刷長実績',
    label_machine_screen_sheets_per_h: '生産能力(m/時)',
    label_machine_joblist_est_hourlyunits: '想定印刷長(m/時)',
    label_machine_joblist_act_hourlyunits: '実績印刷長(m/時)',
    header_machine_setting_remove_group_confirmation: 'グループ「{group}」を削除しますか？',
    machinedetail_passed_day: '(過去7日)',
    machinedetail_passed_week: '(過去4週)',
    machinedetail_passed_month: '(過去4か月)',
    label_machine_waste_paper_length: 'ヤレ長',
    change_disabled_date_heading: '期間',
    change_disabled_date_explanation: 'CSV出力の対象期間',
    ce_edit_transportLog: '転送ログ',
    ce_edit_transportLog_dialog_title: '転送ログ設定',
    ce_edit_transportLog_dialog_no: 'No.',
    ce_edit_transportLog_dialog_dev_env: '転送dev',
    ce_edit_transportLog_dialog_dev_stag: '転送sam',
    current_page: '現在のページ:',
    total_pages: '総ページ数:',
    ds_version_title: 'バージョン情報',
    ds_version_oss: 'OSS情報の公開',
    ds_dashboard_version: 'KONICA MINOLTA AccurioPro Dashboard CE Version',
    ds_version_ds_num: '1.4.3',
    ds_version_copyright: 'Copyright(C)2022',
    ds_version_companyName: 'KONICA MINOLTA.INC.',
    ds_import_cancle_btn: '閉じる',
    header_settingMenu_version: 'バージョン情報',
    ce_application_sub_title: 'カスタマーエンジニア向け',
    ce_authorizer: '承認者Eメールアドレス',
    ce_addCustomers_JMAndAQA_title : "JobManagerとOp-Analysisの両方",
    ce_addCustomers_ScheduleJM_title : "新JobManager",
    ce_addCustomers_Schedule_switch_label : "スケジューリング機能",
    ce_addCustomers_flux_switch_label : "FLUX 連携機能",
    ce_editCustomers_flux_endpoint_url: "endpoint urlをクリップボードにコピー",
    ce_request_subTitle : "顧客情報",
    ce_request_header_date : "リクエスト日時",
    ce_request_header_contents : "内容",
    ce_header_link_request : "リクエスト確認",
    ce_edit_email_button: '編集',
};
export default ja;
